class ConsentDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelector('button')?.addEventListener('click', this.onButtonClick.bind(this));
    document.addEventListener('DOMContentLoaded', this.onInit.bind(this));
  }

  onInit() {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('something went wrong with consent-tracking-api');
        }
      }
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const consentInput = this.querySelector('input[type="checkbox"]');
    const consentInputValue = consentInput.checked;

    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: consentInputValue,
        marketing: consentInputValue,
        preferences: consentInputValue,
        sale_of_data: consentInputValue,
      },
      () => this.hide()
    );
  }
}
customElements.define('consent-dialog', ConsentDialog);
